import { Component, inject, isDevMode } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'gt-web-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  translocoService = inject(TranslocoService);
  public isDev = isDevMode();

  constructor() {
    // Leer el idioma de los query params de la URL
    const urlParams = new URLSearchParams(window.location.search);
    const language = urlParams.get('language');
    if (language) {
      this.translocoService.setActiveLang(language);
    }

    // También escuchar mensajes para cambios dinámicos de idioma
    window.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'queryParams') {
        this.translocoService.setActiveLang(event.data.language ?? 'es');
      }
    });
  }
}
